import { render, staticRenderFns } from "./BlockDetails.vue?vue&type=template&id=03b0a648&scoped=true"
import script from "./BlockDetails.vue?vue&type=script&lang=js"
export * from "./BlockDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0a648",
  null
  
)

export default component.exports